import { render, staticRenderFns } from "./newUploaders.vue?vue&type=template&id=cc2be3d8&scoped=true&"
import script from "./newUploaders.vue?vue&type=script&lang=js&"
export * from "./newUploaders.vue?vue&type=script&lang=js&"
import style0 from "./newUploaders.vue?vue&type=style&index=0&id=cc2be3d8&prod&lang=less&scoped=true&"
import style1 from "./newUploaders.vue?vue&type=style&index=1&id=cc2be3d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2be3d8",
  null
  
)

export default component.exports